import { render, staticRenderFns } from "./AvailableFlagsSelector.vue?vue&type=template&id=0b8eeaf1"
import script from "./AvailableFlagsSelector.vue?vue&type=script&lang=ts"
export * from "./AvailableFlagsSelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports